import React from 'react'
import { Button, Flex, Link, toast } from '@workwhile/ui'
import { Copy } from 'lucide-react'

interface CopyableLinkProps {
  /** The text to display inside the link and copy to the clipboard. */
  label: string | number
  /** The destination the link navigates to. */
  link: string
  /** Open the link in a new tab. Defaults to true. */
  newTab?: boolean
  /** Optional override for the copy success toast message. */
  copyMessage?: string
}

export const CopyableLink = ({
  label,
  link,
  newTab = true,
  copyMessage = 'Copied to clipboard',
}: CopyableLinkProps) => {
  const handleCopy = (e: React.MouseEvent) => {
    // Prevent the click from toggling parent rows / following the link.
    e.preventDefault()
    e.stopPropagation()
    navigator.clipboard
      .writeText(String(label))
      .then(() => toast.success(copyMessage))
      .catch(() => toast.error('Failed to copy'))
  }

  return (
    <Flex
      as="span"
      alignItems="center"
      style={{ display: 'inline-flex', gap: 4, verticalAlign: 'middle' }}
    >
      <Link to={link} target={newTab ? '_blank' : undefined}>
        {label}
      </Link>
      <Button
        variant="text"
        kind="small"
        title="Copy"
        aria-label="Copy"
        onClick={handleCopy}
        style={{ padding: 2, minWidth: 'auto', color: '#697386' }}
      >
        <Copy size={14} />
      </Button>
    </Flex>
  )
}
